var OrgEntity = Backbone.Model.extend({
    initialize: function (data, options) {
        this.session = options.session;
        this.bind('change:connections', this.parseConnections, this);
        this.parseConnections();
    },
    
    isAdmin: function () {
        return !!this.get('admin');
    },
    haveJoined: function () {
        return this.session.hasConnections();
    },
    hasSubscribed: function () {
        return true;
    },
    hasConnections: function () {
        return !!(this.connections && this.connections.length);
    },
    hasIrcd: function () {
        return !!this.get('ircd');
    },
    getIrcdConnection: function () {
        if (!this.hasIrcd()) {
            return;
        }
        return {
            ircd: true,
            channels: this.get('ircd_channels')
        };
    },
    parseConnections: function () {
        if (this.get('connections')) {
            var previousConnections = _.clone(this.connections);
            this.connections = this.get('connections');
            this.trigger('connectionsChange', {
                previous: previousConnections
            });
        }
    }
});


module.exports = OrgEntity;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/orgentity.js
// module id = gEBD
// module chunks = 1